import { render, staticRenderFns } from "./paymentdetail.vue?vue&type=template&id=5bff9bfc&scoped=true&"
import script from "./paymentdetail.vue?vue&type=script&lang=js&"
export * from "./paymentdetail.vue?vue&type=script&lang=js&"
import style0 from "./paymentdetail.vue?vue&type=style&index=0&id=5bff9bfc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff9bfc",
  null
  
)

export default component.exports